import * as actionTypes from "./actionTypes"
import Request from "../components/Request/Request";


export function getTranslationsSuccess(data) {
    return {
        type: actionTypes.GET_TRANSLATIONS_SUCCESS,
        payload: data
    }
}

export function getListSuccess(data) {
    return {
        type: actionTypes.GET_LANGUAGE_LIST_SUCCESS,
        payload: data
    }
}

export function getTranslations(lang) {
       
    if(lang === undefined){
        let localLanguage =JSON.parse(localStorage.getItem('language'));
        if(localLanguage == null){
            let lll = {"name":"Türkçe","code":"tr"};
            localStorage.setItem('language', JSON.stringify(lll)); 
            localLanguage =JSON.parse(localStorage.getItem('language'));
        } 
        lang =localLanguage;
                
    } 

    return function (dispatch) {
        //debugger; 
        // let urlLang = undefined;
        // if ( lang !== null){
        //     urlLang =localLanguage.code
        // }
        dispatch(getTranslationsSuccess(lang));
    }
}

export const changeLanguage = (lang) => {
    return function (dispatch) {
        localStorage.setItem('language', JSON.stringify(lang)); 

        dispatch(getTranslations(lang));
    }
}

export function getList() {
    return function (dispatch) {
        let url = "/api/language/getUiList";
        const request = new Request(url );
        request.run()
            .then(response => {
                dispatch(getListSuccess(response.data.data));
            })
            .catch(error => {
                console.log(error.error);
                dispatch(getListSuccess([]));
            });
    }
}
